import { defineMessages } from "react-intl";

export const messages = defineMessages({
    searchFormPlaceholder: {
        id: "search.form.placeholder",
        defaultMessage: "Search",
    },
    searchFormPlaceholderFocused: {
        id: "search.form.placeholder-focused",
        defaultMessage: "Search for albums by title, UPC/EAN, etc.",
    },
    searchResultsTitle: {
        id: "search.results.title",
        defaultMessage: "Search results for \"{query}\"",
    },
    searchResultsFound: {
        id: "search.results.found",
        defaultMessage: `Found {total, plural,
            =0 {no results}
            other {{albums, plural,
                =0 {}
                one {one product}
                other {# products}
            } {tracks, plural,
                =0 {}
                one { {albums, plural, =0 {} other {and}} one track}
                other { {albums, plural, =0 {} other {and}} # tracks}
            }}
        }`,
    },
    searchResultsError: {
        id: "search.results.error",
        defaultMessage: "You must enter a search query.",
    },
});
